module.exports = __webpack_public_path__ + "img/www.rottentomatoes.com.ab2f6d4e.png";